import { render } from "./DownloadAPP.vue?vue&type=template&id=96ef633c&scoped=true"
import script from "./DownloadAPP.vue?vue&type=script&lang=js"
export * from "./DownloadAPP.vue?vue&type=script&lang=js"

import "./DownloadAPP.vue?vue&type=style&index=0&id=96ef633c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96ef633c"]])

export default __exports__